import { render, staticRenderFns } from "./SendCounterPhoto.vue?vue&type=template&id=0f20f3e5&scoped=true&"
import script from "./SendCounterPhoto.vue?vue&type=script&lang=js&"
export * from "./SendCounterPhoto.vue?vue&type=script&lang=js&"
import style0 from "./SendCounterPhoto.vue?vue&type=style&index=0&id=0f20f3e5&prod&lang=css&"
import style1 from "./SendCounterPhoto.vue?vue&type=style&index=1&id=0f20f3e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20f3e5",
  null
  
)

export default component.exports